exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-4c9dc8dc] {\n  height: 100%;\n  box-sizing: border-box;\n  background: #f6f5f8;\n}\n#Return_Bar[data-v-4c9dc8dc] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n  background: #fff;\n}\n[data-v-4c9dc8dc] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-4c9dc8dc] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n.isreturn[data-v-4c9dc8dc] {\n  color: #262626;\n  cursor: pointer;\n  margin-top: 2px;\n}\n.timestyle[data-v-4c9dc8dc] {\n  margin: 0 20px;\n  height: 28px;\n  line-height: 28px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c9dc8dc","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/newservice/OperationRecord.vue
// module id = 1659
// module chunks = 0